import { Badge as MUIBadge, BadgeProps } from '@mui/material';

export { type BadgeProps } from '@mui/material';

export function Badge(props: BadgeProps) {
  return <MUIBadge {...props} />;
}
